/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Meta_TitleInputs */

const en_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const es_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const de_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const zh_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客 | Mark Egly Golf`)
};

const ar_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدونة | Mark Egly Golf`)
};

const fr_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const vi_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const sw_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogu | Mark Egly Golf`)
};

const th_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อก | Mark Egly Golf`)
};

const bs_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const ja_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブログ | Mark Egly Golf`)
};

const ko_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블로그 | Mark Egly Golf`)
};

const pt_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const it_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const sv_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogg | Mark Egly Golf`)
};

const nl_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const da_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const nb_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const fi_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogi | Mark Egly Golf`)
};

const pl_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const ru_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блог | Mark Egly Golf`)
};

const tr_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const hi_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्लॉग | Mark Egly Golf`)
};

const id_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const ms_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const cs_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const el_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const he_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בלוג | Mark Egly Golf`)
};

const af_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

const hu_blog_meta_title = /** @type {(inputs: Blog_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Blog \| Mark Egly Golf" |
*
* @param {Blog_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_meta_title = /** @type {((inputs?: Blog_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_meta_title(inputs)
	if (locale === "de") return de_blog_meta_title(inputs)
	if (locale === "zh") return zh_blog_meta_title(inputs)
	if (locale === "ar") return ar_blog_meta_title(inputs)
	if (locale === "fr") return fr_blog_meta_title(inputs)
	if (locale === "vi") return vi_blog_meta_title(inputs)
	if (locale === "sw") return sw_blog_meta_title(inputs)
	if (locale === "th") return th_blog_meta_title(inputs)
	if (locale === "bs") return bs_blog_meta_title(inputs)
	if (locale === "ja") return ja_blog_meta_title(inputs)
	if (locale === "ko") return ko_blog_meta_title(inputs)
	if (locale === "pt") return pt_blog_meta_title(inputs)
	if (locale === "it") return it_blog_meta_title(inputs)
	if (locale === "sv") return sv_blog_meta_title(inputs)
	if (locale === "nl") return nl_blog_meta_title(inputs)
	if (locale === "da") return da_blog_meta_title(inputs)
	if (locale === "nb") return nb_blog_meta_title(inputs)
	if (locale === "fi") return fi_blog_meta_title(inputs)
	if (locale === "pl") return pl_blog_meta_title(inputs)
	if (locale === "ru") return ru_blog_meta_title(inputs)
	if (locale === "tr") return tr_blog_meta_title(inputs)
	if (locale === "hi") return hi_blog_meta_title(inputs)
	if (locale === "id") return id_blog_meta_title(inputs)
	if (locale === "ms") return ms_blog_meta_title(inputs)
	if (locale === "cs") return cs_blog_meta_title(inputs)
	if (locale === "el") return el_blog_meta_title(inputs)
	if (locale === "he") return he_blog_meta_title(inputs)
	if (locale === "af") return af_blog_meta_title(inputs)
	if (locale === "hu") return hu_blog_meta_title(inputs)
	return en_blog_meta_title(inputs)
});